module.exports = __webpack_public_path__ + "img/clicksource2.e7150b76.png";